export const GENDER_OPTIONS = [
  { value: 'male', label: 'Male' },
  { value: 'female', label: 'Female' },
  { value: 'other', label: 'Other' },
];

export const AGE_LIMITS = {
  MIN: 18,
  MAX: 65,
};

export const PERSONAL_DETAILS_LIMITS = {
  NAME_MAX: 100,
  COMPANY_MAX: 100,
  LOCATION_MAX: 100,
  DESCRIPTION_MAX: 1000,
  PHONE_LENGTH: 10,
};
